import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: reports.StudentReportSectionElement.
export default class StudentReportSectionElement extends Fragment {
  declare [Type]: 'reports/student-report-section-element';

  @attr('string', { defaultValue: '' })
  declare elementId: string;

  @attr('string', { defaultValue: '' })
  declare judgement: string;

  @attr('string', { defaultValue: '' })
  declare effort: string;
}
